import { EnumAppActions } from './app_actions';
import { EnumAccountActions } from '../ui/account/account_actions';
import update from 'immutability-helper';
import { AppConstants } from '../constants/AppConstants';


const initialState = {
    deviceSize: null,
    locate: AppConstants.DEFAULT_LANG,
    listOfNotify: null,
    jsessionId: null,
    serverid: null,

    loadingStack: 0,
    toogleLoading: 'hide',

    authorizations: {},

    domini: {},
    dominiLoaded: false,

    i18nlabels: {},
    i18nlabelsLoaded: true, // TODO riportare a false e nel loading ri-set to true

    opzioni: {},
    opzioniLoaded: false,

    loggedOut: false,
    versionInformation: null,
    debugObj: null,
    showPopUp: false,


    initialized: function () {
        return this.dominiLoaded && this.i18nlabelsLoaded && this.opzioniLoaded;
    }
};

const app = (state, action) => {

    if (typeof state === 'undefined') {
        return initialState
    }

    let newState = null;
    let notifyCollection = null;

    //console.log('[Reducer app] action: ' + action.type);

    switch (action.type) {
        case EnumAccountActions.LOGIN_SUCCESS:
            console.log('[Reducer account] action: ' + action.type);
            console.log('\t LOGIN_SUCCESS');
            console.log('\t user.id' + action.user.id);

            let permessiCodes = action.user.authorizations;
            let permessi = {};

            if (permessiCodes) {
                permessiCodes.forEach(element => {
                    permessi[element] = element;
                });

            }

            //stessa funzionalità di assign
            return update(state, {
                $merge: {
                    authorizations: permessi,
                    jsessionId: action.user.jsessionId,
                    listOfNotify: null
                }
            });

        case EnumAccountActions.LOGOUT:
            console.log('[Reducer app] action: ' + action.type);
            // return Object.assign({}, state, {
            //     loggedOut: true,
            //     datiUtente: {}
            // });
            return Object.assign({}, state, initialState);

        case EnumAppActions.NOTIFY_MESSAGE_ADD:
            console.log('[Reducer app] action: ' + action.type);
            //console.log('message: ' + action.message);
            //console.log('messageType: ' + action.messageType);

            if (state.listOfNotify === null) {
                notifyCollection = new Map();
            } else {
                //devo clonare la lista altrimenti non vengono intercettati i cambiamenti
                notifyCollection = new Map(state.listOfNotify);
                //  notifyCollection = Object.assign(new Map(), state.listOfNotify);
                //notifyCollection = state.listOfNotify;
            }

            if (action.messageId === null || action.messageId === undefined) {
                action.messageId = new Date().getTime();
            }

            notifyCollection.set(Number(action.messageId), {
                message: action.message,
                messageType: action.messageType,
                messageId: action.messageId
            });


            return Object.assign({}, state, {
                listOfNotify: notifyCollection
            });
        case EnumAppActions.NOTIFY_MESSAGE_DELETE:
            //console.log('[ReducerA PP] action: ' + action.type + ' - messageId: ' + action.messageId);

            //devo clonare la lista altrimenti non vengono intercettati i cambiamenti
            //notifyCollection = Object.assign(new Map(), state.listOfNotify);
            notifyCollection = new Map(state.listOfNotify);
            notifyCollection.delete(action.messageId);

            return Object.assign({}, state, {
                listOfNotify: notifyCollection
            });

        case EnumAppActions.NOTIFY_MESSAGE_CLEAR:
            console.log('[Reducer app] action: ' + action.type);
            return Object.assign({}, state, { listOfNotify: null });

        case EnumAppActions.LOAD_DOMINI:
            console.log('[Reducer app] action: ' + action.type);

            newState = Object.assign({}, state, {
                domini: update(state.domini, {
                    $merge: action.domini
                }),
                dominiLoaded: true
            });
            return newState;

        case EnumAppActions.LOAD_OPZIONI:
            console.log('[Reducer app] action: ' + action.type);

            newState = Object.assign({}, state, {
                opzioni: update(state.opzioni, {
                    $merge: action.opzioni
                }),
                opzioniLoaded: true
            });
            return newState;


        case EnumAppActions.LOAD_I18N:
            console.log('[Reducer app] action: ' + action.type);

            let obj = {};
            if (action.result !== undefined && action.result.labelCode) {
                obj[action.result.labelCode] = action.result.labelDefault;
            }

            if (action.i18nlabels !== undefined) {
                obj = action.i18nlabels;
            }

            newState = Object.assign({}, state, {
                i18nlabels: update(state.i18nlabels, {
                    $set: obj
                })
            });

            return newState;


        case EnumAppActions.WINDOW_WIDTH_CHANGED:
            return Object.assign({}, state, {
                deviceSize: action.deviceSize
            });


        case EnumAppActions.LOADER_SHOW:
            console.log('[Reducer app] action: ' + action.type);

            if (state.toogleLoading === 'show') {
                newState = update(state, {
                    $merge: {
                        loadingStack: state.loadingStack + 1
                    }
                });
            } else {
                newState = update(state, {
                    $merge: {
                        toogleLoading: "show",
                        loadingStack: 1
                    }
                });
            }
            return newState;

        case EnumAppActions.LOADER_HIDE:
            console.log('[Reducer app] action: ' + action.type);

            if (state.toogleLoading === 'hide') {
                newState = update(state, {
                    $merge: {
                        toogleLoading: "hide",
                        loadingStack: 0
                    }
                });
            }
            else {
                if (state.loadingStack > 1) {
                    newState = update(state, {
                        $merge: {
                            loadingStack: state.loadingStack - 1
                        }
                    });
                } else {
                    newState = update(state, {
                        $merge: {
                            toogleLoading: "hide",
                            loadingStack: 0
                        }
                    });
                }
            }
            return newState;

        case EnumAppActions.VERSION_INFO:
            return Object.assign({}, state, {
                versionInformation: action.versionInformation,
            })
        case EnumAppActions.DEBUG:
            return Object.assign({}, state, {
                debugObj: action.debugObj,
            })

        case EnumAppActions.SHOW_POPOUP:
            return update(state, action.showPopUp);

        case EnumAppActions.LOCATE_CHANGE:
            console.log('[Reducer app] action: ' + action.type);
            return Object.assign({}, state, { locate: action.locate });
        case EnumAppActions.ADD_I18N:
            console.log('[Reducer app] action: ' + action.type);

            newState = Object.assign({}, state, {
                i18nlabels: update(state.i18nlabels, {
                    $merge: action.i18nToSave
                }),
            });
            return newState;
        default:
            return state
    }
}

export default app